import React from 'react';
import { FileText } from 'lucide-react';

export default function ReconciliationModal({ reconModal, setReconModal, reconForm, setReconForm, submitReconciliation, auditData }) {
  if (!reconModal) return null;
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={e => { if (e.target === e.currentTarget) setReconModal(false); }}>
      <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl">
        <div className="px-6 py-4 border-b">
          <h3 className="font-semibold text-lg">Request Reconciliation</h3>
          <p className="text-xs text-gray-500 mt-1">This will create an approval request for a manager to review</p>
        </div>
        <div className="p-6 space-y-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-3">
            <p className="text-sm font-semibold text-red-800">Variance: S${auditData.reconciliation?.reconciliation?.variance}</p>
            <p className="text-xs text-red-600 mt-1">Expected: S${auditData.reconciliation?.reconciliation?.expected_inventory_value} | Actual: S${auditData.reconciliation?.reconciliation?.actual_inventory_value}</p>
          </div>
          <div>
            <label className="text-xs font-medium text-gray-600 mb-1 block">Category *</label>
            <select value={reconForm.category} onChange={e => setReconForm(p => ({ ...p, category: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-sm">
              <option value="shrinkage">Shrinkage (theft/loss)</option>
              <option value="damage">Damaged goods written off</option>
              <option value="data_entry_error">Data entry error</option>
              <option value="system_migration">System migration discrepancy</option>
              <option value="rounding">Rounding differences</option>
              <option value="sample_data">Sample/test data cleanup</option>
              <option value="unidentified">Unidentified — requires investigation</option>
            </select>
          </div>
          <div>
            <label className="text-xs font-medium text-gray-600 mb-1 block">Reason / Explanation *</label>
            <textarea value={reconForm.reason} onChange={e => setReconForm(p => ({ ...p, reason: e.target.value }))}
              className="w-full border rounded-lg px-3 py-2 text-sm h-24 resize-none focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Explain why this variance exists and why a write-off is justified..." />
          </div>
        </div>
        <div className="flex justify-end gap-3 px-6 py-4 border-t">
          <button onClick={() => setReconModal(false)} className="px-4 py-2 text-sm text-gray-600 border rounded-lg hover:bg-gray-50">Cancel</button>
          <button onClick={submitReconciliation} disabled={!reconForm.reason.trim()}
            className="px-4 py-2 text-sm bg-amber-500 text-white rounded-lg hover:bg-amber-600 disabled:bg-gray-300 font-medium">Submit for Approval</button>
        </div>
      </div>
    </div>
  );
}
